import { makeStyles } from 'tss-react/mui';
const useStyles = makeStyles()((theme) => ({
    noResults: {
        textAlign: 'center',
    },
    hide: {
        display: 'none',
    },
    show: {
        display: 'block',
    },
    blogArticleGallery: {
        gridTemplateColumns: 'repeat(1, 1fr)',
        [theme.breakpoints.up('sm')]: {
            gridTemplateColumns: 'repeat(1, 1fr)',
        },
        [theme.breakpoints.up('md')]: {
            gridTemplateColumns: 'repeat(2, 1fr)',
        },
        [theme.breakpoints.up('lg')]: {
            gridTemplateColumns: 'repeat(3, 1fr)',
        },
    },
}));
export default useStyles;
